import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { cloneDeep } from 'lodash';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Component({
  selector: 'cv-configure-rewards-multiplier',
  templateUrl: './configure-rewards-multiplier.component.html',
  styleUrls: ['./configure-rewards-multiplier.component.scss']
})
export class ConfigureRewardsMultiplierComponent implements OnInit {
  @Input() step: number;
  @Input() componentOptions: any;
  @Output() componentComplete: EventEmitter<any> = new EventEmitter<any>();

  gs = null;
  consideredComplete: boolean = false;
  hasCoins: boolean = false;
  hasXP: boolean = false;
  hasCurrency: boolean = false;
  hasBadge: boolean = false;
  rewards: any;

  //Variables for controlling the textbox's show state and default values
  coinsEditing: boolean = false;
  coinsMaxEditing: boolean = false;
  xpEditing: boolean = false;
  xpMaxEditing: boolean = false;
  currencyEditing: boolean = false;
  currencyMaxEditing: boolean = false;
  
  //Variables to help measure the text to resize the textboxes accordingly. styleString should match the style that is set for the element
  minTextBoxSize: number = 40;        //The smallest the textbox can be (minus the breatheSpace)
  maxTextBoxSize: number = 200;       //The largest the textbox can be (plus the breathSpace)
  breatheSpace: number = 10;          //The space that is added after measuring the text. This is essentially padding
  styleString: string = "60px roboto";//Match to the style of the element that is being measured
  isCxone = false;

  constructor(
    private gamesService: GamesService,
    public cvConfigurationService: CvConfigurationService
  ) { 
    this.gs = this.gamesService.data;
  }

  ngOnInit(): void {
    //Set the different reward toggles based on what was set in the factory's game definition (isSet is a function on the GamesFactory's rewardOptions 'enum')
    this.hasCoins = this.gs.rewardOptions.isSet(this.componentOptions.rewardsAvailable, this.gs.rewardOptions.Coins);
    this.hasXP = this.gs.rewardOptions.isSet(this.componentOptions.rewardsAvailable, this.gs.rewardOptions.XP);
    this.hasCurrency = this.gs.rewardOptions.isSet(this.componentOptions.rewardsAvailable, this.gs.rewardOptions.Currency);
    this.hasBadge = this.gs.rewardOptions.isSet(this.componentOptions.rewardsAvailable, this.gs.rewardOptions.Badge);

    //If MultiplierMadnessRewards is set, assign it to itself (for edit purposes). Otherwise, create a default for new games to use
    this.gs.modified.item.MultiplierMadnessRewards = this.gs.modified.item.MultiplierMadnessRewards || {
      coins: 0,
      xp: 0,
      currency: 0,
      maxCoinsPayout: null,
      maxXpPayout: null,
      maxCurrencyPayout: null
    };

    //Shortcut for template
    this.rewards = this.gs.modified.item.MultiplierMadnessRewards;
    this.isCxone = this.cvConfigurationService.isCxOne;
  }

  addMaxPayout (type) {
    switch (type) {
      case 'coins': this.gs.modified.item.MultiplierMadnessRewards.maxCoinsPayout = 1; this.rewards.hasMaxCoins = true; break;
      case 'xp': this.gs.modified.item.MultiplierMadnessRewards.maxXpPayout = 1; this.rewards.hasMaxXP = true; break;
      case 'currency': this.gs.modified.item.MultiplierMadnessRewards.maxCurrencyPayout = 1; this.rewards.hasMaxCurrency = true; break;
    }
  }

  removeMaxPayout (type) {
    switch (type) {
      case 'coins': this.rewards.maxCoinsPayout = null; this.rewards.hasMaxCoins = false; break;
      case 'xp': this.rewards.maxXpPayout = null; this.rewards.hasMaxXP = false; break;
      case 'currency': this.rewards.maxCurrencyPayout = null; this.rewards.hasMaxCurrency = false; break;
    }
  }

  //Hide the textbox on click off
  handleBlur ($event, boxType) {
    var $elem = $($event.target);
    var resetToZero = false; //If the box is empty or invalid, should the value reset to zero?
    if ($elem != null) {
      var val = parseFloat($elem[0].value);
      if (val == null || isNaN(val)) {
        resetToZero = true;
      }
    }

    switch (boxType) {
      case 'coins':
        this.coinsEditing = false;
        if (resetToZero)
          this.gs.modified.item.MultiplierMadnessRewards.coins = 0;
        break;
      case 'xp':
        this.xpEditing = false;
        if (resetToZero)
          this.gs.modified.item.MultiplierMadnessRewards.xp = 0;
        break;
      case 'currency':
        this.currencyEditing = false;
        if (resetToZero)
          this.gs.modified.item.MultiplierMadnessRewards.currency = 0;
        break;
      case 'coinsMax':
        this.coinsMaxEditing = false;
        if (resetToZero)
          this.gs.modified.item.MultiplierMadnessRewards.maxCoinsPayout = 0;
        break;
    }

    if (resetToZero) //If resetToZero happened, the box needs to be re-measured
      this.fitElemToVal($elem);

    if (!this.consideredComplete && (this.gs.modified.item.MultiplierMadnessRewards.coins > 0 || this.gs.modified.item.MultiplierMadnessRewards.xp > 0 || this.gs.modified.item.MultiplierMadnessRewards.currency > 0)) {
      this.consideredComplete = true;
      
      var eventArgs = {
          currentStep: this.step - 1,
          unlocks: this.componentOptions.unlocks
      };
      
      this.componentComplete.emit(eventArgs);
    }
  }

  //Set the corresponding Editing flag and focus the input
  showAndFocusTextbox ($event, boxType) {
    switch (boxType) {
      case 'coins': this.coinsEditing = true; break;
      case 'xp': this.xpEditing = true; break;
      case 'currency': this.currencyEditing = true; break;
      case 'coinsMax': this.coinsMaxEditing = false; break;
    }

    var $elemParent = $($event.target).parent();
    
    setTimeout(() => {
      var $input = $elemParent.find("input");
      if ($input != null) {
          this.fitElemToVal($input);
          $input.focus();
      }
    }, 1);
  }

  //Public wrapper to fitElemToVal
  resizeTextbox ($event) {
    var $elem = $($event.target);
    if ($elem != null) {
      this.fitElemToVal($elem);
    }
  }

  //Resizes the box to fit the value based on the variables set above
  fitElemToVal ($elem) {
    var textWidth = this.getTextWidth($elem.val(), this.styleString);
    textWidth = Math.max(this.minTextBoxSize, textWidth + this.breatheSpace);
    textWidth = Math.min(this.maxTextBoxSize - this.breatheSpace, textWidth);
    textWidth += this.breatheSpace;
    $elem.width(textWidth);
  };

  //https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript
  getTextWidth(text, font) {
    var canvas = document.createElement("canvas");
    var context = canvas.getContext("2d");
    context.font = font;
    var metrics = context.measureText(text);
    return Math.round(metrics.width);
  }

  onRewardInputChange(value: any, field: string): void {
    // Convert the value to a number and replace invalid values ​​with 0
    let parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue) || parsedValue < 0) {
        parsedValue = 0;
    }
    // Update the data model with the validated value
    this.gs.modified.item.MultiplierMadnessRewards[field] = parsedValue;
  }
}
